import {
  ADMIN_MY_PRODUCTS_3DMODAL_EACH_PUBLIC_V2,
  ADMIN_MY_PRODUCTS_3DMODAL_EACH_V2,
  ADMIN_MY_PRODUCTS_3DMODAL_V2,
  ADMIN_MY_PRODUCTS_ROOMS_V2,
  ADMIN_MY_PRODUCTS_TEXTURES_EACH_V2,
  ADMIN_MY_TEXTURES_3DMODAL_EACH_PUBLIC_V2,
  CONFIGURATOR_PUBLIC_VIEWER_ROUTE,
  CONFIGURATOR_PUBLIC_VIEWER_ROUTE_TEXTURE_V2,
  PRODUCT_360_VIEWER_PUBLIC_V2,
  PRODUCT_3D_VIEWER_PUBLIC_V2,
  PRODUCT_AI_VIDEO_PUBLIC_TEXTURE_V2,
  PRODUCT_AI_VIDEO_PUBLIC_V2,
  PRODUCT_AR_VIEWER_PUBLIC_V2,
  PRODUCT_VIDEO_PUBLIC_V2,
  RENDER_DETAILS,
  RENDER_DETAILS_V2,
  TEMPLATES_ROUTE_V2,
  TEXTURE_360_VIEWER_PUBLIC_V2,
  TEXTURE_VIDEO_PUBLIC,
} from './routePathConstants';
import { ROOM_TYPE, TEMPLATE_TYPE } from './projectConstants';

import {
  ADMIN_MY_PROPS_V2,
  ADMIN_MY_PRODUCTS_3DMODAL_EACH,
  ADMIN_MY_PRODUCTS_TEXTURE_EDIT_V2,
} from '../config/constant/routePathConstant';
import { getCuratorPath } from '../helpers/urlHelper';
import { getProjectTypeLabel } from '../helpers/dataHelper';

const PROJECT_TYPE_OPTIONS = [
  {
    label: getProjectTypeLabel(ROOM_TYPE.LIFESTYLE),
    value: ROOM_TYPE.LIFESTYLE,
  },
  {
    label: getProjectTypeLabel(ROOM_TYPE.SILO),
    value: ROOM_TYPE.SILO,
  },
  {
    label: getProjectTypeLabel(ROOM_TYPE.VIGNETTE),
    value: ROOM_TYPE.VIGNETTE,
  },
];

const TEMPLATE_TYPE_OPTIONS = [
  {
    label: getProjectTypeLabel(TEMPLATE_TYPE.LIFESTYLE),
    value: TEMPLATE_TYPE.LIFESTYLE,
  },
  {
    label: getProjectTypeLabel(TEMPLATE_TYPE.VIGNETTE),
    value: TEMPLATE_TYPE.VIGNETTE,
  },
  {
    label: getProjectTypeLabel(TEMPLATE_TYPE.SILO),
    value: TEMPLATE_TYPE.SILO,
  },
];

// export const FAILED_REASON = {
//   1: 'Due to ownership rights',
//   2: 'Not Found/May be someone deleted it',
// };
export const FAILED_REASON = {
  1: 'Due to ownership rights',
  2: 'Used in project', // 'Permission denied, Texture is used in the project'
  3: 'Not Found/May be someone deleted it', // 'Object Not Found!'
  4: 'If texture is_map set to true then must be provided project id',
  5: 'Used in automation',
};

export const STATUS_NOT_DONE_KEY = 0;
export const STATUS_DONE_KEY = 1;
export const STATUS_PROCESSING_KEY = 2;
export const STATUS_FAILED_KEY = 3;
export const STATUS_DISABLED_KEY = 4;
export const STATUS_BLENDER_PROCESSING_KEY = 5;
export const STATUS_INFECTED_KEY = 6;

export const RENDER_STATUS = {
  STATUS_NOT_DONE: 0,
  STATUS_DONE: 1,
  STATUS_PROCESSING: 2,
  STATUS_FAILED: 3,
  STATUS_DISABLED: 4,
};
// STATUS_UNDER_REVIEW: 5, // yet not included as this is not checked from the backend

export const STATUS_NOT_DONE = 'Not Done';
const STATUS_DONE = 'Done';
const STATUS_PROCESSING = 'In Queue';
const STATUS_FAILED = 'Failed !';
export const STATUS_DISABLED = 'Disabled';

export const RENDER_STATUS_OPTIONS = [
  {
    value: RENDER_STATUS.STATUS_NOT_DONE,
    label: STATUS_NOT_DONE,
  },
  {
    value: RENDER_STATUS.STATUS_DONE,
    label: STATUS_DONE,
  },
  {
    value: RENDER_STATUS.STATUS_PROCESSING,
    label: STATUS_PROCESSING,
  },
  {
    value: RENDER_STATUS.STATUS_FAILED,
    label: STATUS_FAILED,
  },
  {
    value: RENDER_STATUS.STATUS_DISABLED,
    label: STATUS_DISABLED,
  },
];
export const USER_ROLE_IDS = {
  // This is still somewhat tenative, per Aakash 04/28/2022
  // He said that role #5 is not in use anywhere on the API side yet
  ADMIN: 5,
  MEMBER: 6,
};

export const INTERNAL_USER_ROLES = [USER_ROLE_IDS.MEMBER];
export const USER_ROLES = [
  { label: 'Member', value: USER_ROLE_IDS.MEMBER },
  { label: 'Admin', value: USER_ROLE_IDS.ADMIN },
];

export const MODULE_TYPE_OPTIONS = {
  // -> this represents collection module types
  PROPS: 1,
  THREEDMODELS: 2,
  TEXTURES: 3,
  UPLOADS: 4,
  ROOMS: 5,
  TEMPLATES: 6,
  RENDERS: 7,
  PREVIEWS: 8,
  PROJECT: 9,
  MATERIAL: 10,
  AUTOMATION: 11,
  PRODUCT_CONFIGURTOR: 12,
  SAVE_MATERIAL: 22,
};

const COLLECTION_MODEL_TYPE = MODULE_TYPE_OPTIONS; // TODO: replace variable MODULE_TYPE_OPTIONS with  COLLECTION_MODEL_TYPE

export const GET_MODULE_KEY_BY_ID = (id) => {
  id = parseInt(id, 10);
  switch (id) {
    case MODULE_TYPE_OPTIONS.PROPS:
      return {
        type: MODULE_TYPES.PROPS,
        clickUrl: (id) => { },
      };

    case MODULE_TYPE_OPTIONS.ROOMS:
      return {
        type: MODULE_TYPES.ROOMS,
        clickUrl: (id) => `/templates/${id}`,
      };

    case MODULE_TYPE_OPTIONS.TEMPLATES:
      return {
        type: MODULE_TYPES.TEMPLATES,
        clickUrl: (id) => `/templates/${id}`,
      };

    case MODULE_TYPE_OPTIONS.PROJECT:
      return {
        type: MODULE_TYPES.PROJECTS,
        clickUrl: (id) => getCuratorPath(id, 'projects'),
      };

    case MODULE_TYPE_OPTIONS.RENDERS:
      return {
        type: MODULE_TYPES.RENDERS_PREVIEWS_ROUTE_V2,
        clickUrl: (id) => RENDER_DETAILS_V2.replace(':id', id),
      };

    case MODULE_TYPE_OPTIONS.PREVIEWS:
      return {
        type: MODULE_TYPES.RENDERS_PREVIEWS_ROUTE_V2,
        clickUrl: (id) => RENDER_DETAILS_V2.replace(':id', id),
      };

    // not sure about these, so need to test
    case MODULE_TYPE_OPTIONS.TEXTURES:
      return {
        type: MODULE_TYPES.TEXTURES,
        clickUrl: (id) => { },
      };

    case MODULE_TYPE_OPTIONS.UPLOADS:
      return {
        type: MODULE_TYPES.UPLOADS,
        clickUrl: (id) => { },
      };

    // case MODULE_TYPE_OPTIONS.MATERIAL:
    //   return MODULE_TYPES.RENDER_PREVIEW;

    case MODULE_TYPE_OPTIONS.THREEDMODELS:
      return {
        type: MODULE_TYPES.THREEDMODEL,
        clickUrl: (id) => `/products/my-models/${id}`,
      };

    default:
      // if you have gotten here, then we may have a missing or new module type
      // that we need to know the value from the API team
      return null;
  }
};

/// these are the keys that come back on the sidefilter "order" field
// and other common filter keys
export const FILTER_TYPES = {
  BRANDS: 'brands',
  PRODUCTS: 'products',
  COLLECTIONS: 'collections',
  FILTER_OPTIONS: 'filteroptions',
  FILTER_LABELS: 'filterlabels',
  FAVOURITE: 'is_favourite',
  PAGE: 'page',
  CREATED_BY: 'created_by',
  ORDERED_FILTERS: 'orderedFilters',
};

export const collectionFriendlyTitle = (model_type) => {
  switch (parseInt(model_type, 10)) {
    case MODULE_TYPE_OPTIONS.PROPS:
      return 'Common Prop';
    case MODULE_TYPE_OPTIONS.THREEDMODELS:
      return 'My product';
    case MODULE_TYPE_OPTIONS.TEXTURES:
      return 'Texture';
    case MODULE_TYPE_OPTIONS.UPLOADS:
      return 'Custom Map';
    case MODULE_TYPE_OPTIONS.ROOMS:
      return 'My Room';
    case MODULE_TYPE_OPTIONS.TEMPLATES:
      return 'Common Room';
    case MODULE_TYPE_OPTIONS.RENDERS:
      return 'Render';
    case MODULE_TYPE_OPTIONS.PREVIEWS:
      return 'Preview';
    case MODULE_TYPE_OPTIONS.PROJECT:
      return 'My Project';
    case MODULE_TYPE_OPTIONS.MATERIAL:
      return 'Material';
    case MODULE_TYPE_OPTIONS.AUTOMATION:
      return 'Automation';
  }
};

export const MODULE_TYPES = {
  PRODUCT: 'product',
  PRODUCTS: 'products',
  PROP: 'prop',
  PROPS: 'props',
  TEXTURE: 'texture',
  TEXTURES: 'textures',
  ROOM: 'room',
  ROOMS: 'rooms',
  TEMPLATE: 'template',
  TEMPLATES: 'templates',
  PROJECT: 'project',
  PROJECTS: 'projects',
  PROJECT_RENDER: 'project_render',
  RENDER: 'render',
  RENDERS: 'renders',
  RENDER_DETAIL: 'render-detail',
  RENDER_PREVIEW: 'renders-previews',
  RENDERS_PREVIEWS_ROUTE_V2: '/my-files/images',
  PREVIEW: 'preview',
  PREVIEWS: 'previews',
  COLLECTION: 'collection',
  COLLECTIONS: 'collections',
  MODEL: 'model',
  MODELS: 'models',
  THREEDMODELS: '3dmodels',
  THREEDMODEL: '3dmodel',
  UPLOAD: 'upload',
  UPLOADS: 'uploads',
  AUTOMATION: 'automation',
  CONFIGURATOR: 'configurator',
  PRODUCT_CONFIGURATOR: 'configurator',
  LIBRARY_TEMPLATES: 'library/templates',
  MATERIAL: 'material',
  SHARED_PRODUCT_PAGE: 'library/shared-product-page',
};

// per Aakash 04-May-2022
export const COLLECTION_PROPS = (itemType) => {
  console.log('item type >>> ', itemType);
  switch (itemType) {
    case MODULE_TYPES.PRODUCT:
    case MODULE_TYPES.PROP:
      return MODULE_TYPES.PROP;
    case MODULE_TYPES.ROOM:
    case MODULE_TYPES.TEMPLATE:
      return MODULE_TYPES.ROOM;
    case MODULE_TYPES.PROJECT:
      return MODULE_TYPES.PROJECT;
    case MODULE_TYPES.RENDER:
    case MODULE_TYPES.RENDER_DETAIL:
    case MODULE_TYPES.RENDER_PREVIEW:
    case 'renders-preview':
      return MODULE_TYPES.PROJECT_RENDER;
    case MODULE_TYPES.PREVIEW:
      return MODULE_TYPES.PROJECT_RENDER;
    case MODULE_TYPES.TEXTURE:
    case MODULE_TYPES.UPLOAD:
      return MODULE_TYPES.TEXTURE;
    case MODULE_TYPES.AUTOMATION:
      return MODULE_TYPES.AUTOMATION;
    default:
      throw new Error('item type is not supported');
  }
};

export const MODEL_TYPES = {
  PRODUCT: 1,
  TEXTURE: 2,
  ROOM: 3,
  PROJECTS: 4,
  COLLECTION: 5,
  PROJECTRENDER: 6,
  THREESIXTY: 7,
  THREEDMODELS: 8,
  UPLOADS: 9,
  TEMPLATES: 10,
  PREVIEWS: 11,
  WEBEXPERIENCE: 12,
  TICKET: 13,
  AUTOMATION: 14, // automatio-todo - change this
  CONFIGURATOR: 13,
  CONFIGURATORS: 15,
  REQUEST: 16,
  PRODUCT_CONFIGURATOR: 12,
  LIGHTROOM: 17,
  IMAGINE_AI: 18,
  RETAIL_AUTOMATION: 19,
  RECENT_FILES: 20,
  PRODUCT_BUILDER: 21,
  MATERIAL: 22,
  SHARED_PRODUCT_PAGE:23,
};

export const COMMON_TAGS_MODEL_TYPES = {
  PRODUCT: 'product',
  TEXTURE: 'texture',
  ROOM: 'room',
  PROJECTS: 'project',
  COLLECTION: 'collection',
  PROJECTRENDER: 'projectrender',
  MATERIAL: 'material',
  AUTOMATION: 'automation',
  CONFIGURATOR: 'configurator',
  CONFIGURATORS: 'configurator',
  REQUEST: 'request',
  LIGHTROOM: 'lightroom',
};

export const MODEL_TYPE__COLLECTION_KEY = {
  [MODEL_TYPES.PRODUCT]: MODULE_TYPES.PROP,
  [MODEL_TYPES.TEXTURE]: MODULE_TYPES.TEXTURE,
  [MODEL_TYPES.ROOM]: MODULE_TYPES.ROOM,
  [MODEL_TYPES.PROJECTS]: MODULE_TYPES.PROJECT,
  // [MODEL_TYPES.COLLECTION]: ''
  [MODEL_TYPES.PROJECTRENDER]: MODULE_TYPES.PROJECT_RENDER,
  // [MODEL_TYPES.THREESIXTY]: ''
  [MODEL_TYPES.THREEDMODELS]: MODULE_TYPES.PROP,
  [MODEL_TYPES.UPLOADS]: MODULE_TYPES.TEXTURE,
  [MODEL_TYPES.TEMPLATES]: MODULE_TYPES.ROOM,
  [MODEL_TYPES.PREVIEWS]: MODULE_TYPES.PROJECT_RENDER,
  [MODEL_TYPES.AUTOMATION]: MODULE_TYPES.AUTOMATION,
  [MODEL_TYPES.AUTOMATION]: MODULE_TYPES.AUTOMATION,
  [MODEL_TYPES.CONFIGURATOR]: MODULE_TYPES.CONFIGURATOR,
  [MODEL_TYPES.PRODUCT_CONFIGURATOR]: MODULE_TYPES.PRODUCT_CONFIGURATOR,
  [MODEL_TYPES.MATERIAL]: MODULE_TYPES.MATERIAL
  // [MODEL_TYPES.WEBEXPERIENCE]: ''
};

export const COLLECTION_MODEL_TYPE__MODEL_TYPE__MAP = {
  [COLLECTION_MODEL_TYPE.PROPS]: MODEL_TYPES.PRODUCT,
  [COLLECTION_MODEL_TYPE.THREEDMODELS]: MODEL_TYPES.THREEDMODELS,
  [COLLECTION_MODEL_TYPE.TEXTURES]: MODEL_TYPES.TEXTURE,
  [COLLECTION_MODEL_TYPE.UPLOADS]: MODEL_TYPES.UPLOADS,
  [COLLECTION_MODEL_TYPE.ROOMS]: MODEL_TYPES.ROOM,
  [COLLECTION_MODEL_TYPE.TEMPLATES]: MODEL_TYPES.TEMPLATES,
  [COLLECTION_MODEL_TYPE.RENDERS]: MODEL_TYPES.PROJECTRENDER,
  [COLLECTION_MODEL_TYPE.PREVIEWS]: MODEL_TYPES.PREVIEWS,
  [COLLECTION_MODEL_TYPE.PROJECT]: MODEL_TYPES.PROJECTS,
  [COLLECTION_MODEL_TYPE.MATERIAL]: MODEL_TYPES.MATERIAL,
  [COLLECTION_MODEL_TYPE.AUTOMATION]: MODEL_TYPES.AUTOMATION,
  [COLLECTION_MODEL_TYPE.PRODUCT_CONFIGURTOR]: MODEL_TYPES.PRODUCT_CONFIGURATOR,
};

export const COLLECTION_MODEL_TYPE__SHARE_TYPE__MAP = {
  [COLLECTION_MODEL_TYPE.PROPS]: MODEL_TYPES.PRODUCT,
  [COLLECTION_MODEL_TYPE.THREEDMODELS]: MODEL_TYPES.PRODUCT,
  [COLLECTION_MODEL_TYPE.TEXTURES]: MODEL_TYPES.TEXTURE,
  [COLLECTION_MODEL_TYPE.UPLOADS]: MODEL_TYPES.TEXTURE,
  [COLLECTION_MODEL_TYPE.ROOMS]: MODEL_TYPES.ROOM,
  [COLLECTION_MODEL_TYPE.TEMPLATES]: MODEL_TYPES.ROOM,
  [COLLECTION_MODEL_TYPE.RENDERS]: MODEL_TYPES.PROJECTRENDER,
  [COLLECTION_MODEL_TYPE.PREVIEWS]: MODEL_TYPES.PROJECTRENDER,
  [COLLECTION_MODEL_TYPE.PROJECT]: MODEL_TYPES.PROJECTS,
  [COLLECTION_MODEL_TYPE.MATERIAL]: MODEL_TYPES.MATERIAL,
  [COLLECTION_MODEL_TYPE.AUTOMATION]: MODEL_TYPES.AUTOMATION,
  [COLLECTION_MODEL_TYPE.PRODUCT_CONFIGURTOR]: MODEL_TYPES.PRODUCT_CONFIGURATOR,
};

export const TRASH_MODEL_TYPE = {
  ROOM: 1,
  TEXTURE: 2,
  PROJECT: 3,
  COLLECTION: 4,
  MATERIAL: 5,
  PROJECT_PREVIEW: 6,
  PRODUCT: 7,
  FIXED_PRODUCT: 8,
  UPLOADS: 9, // custom maps
  UPLOADED_RENDER: 10, // render uploads
  AUTOMATION: 11,
  CONFIGURATOR: 12,
  IMAGINE_AI: 13,
  RETAIL_AUTOMATION: 14,
  PRODUCT_BUILDER: 15,
};

export const FILTER_MODEL_TYPE = {
  PROPS: 0,
  ROOM: 1, // for ROOM/PROJECT we have same category model type
  TEXTURE: 2,
  FIXED_PROPS: 3,
  PROJECT_RENDERS: 4,
  MATERIAL: 5,
  TEXTURE_UPLOADS: 6,
  COLLECTION: 7,
};

export const NOTIFICATION_MODEL_TYPE = {
  RenderStatus: 'render_status',
  Preview: 'preview',
  RequestStatusAndComments: 'request_status_and_comments',
  SharedFiles: 'shared_files',
  FromLiveFurnish: 'from_live_furnish',
  LiveOnAppRender: 'live_on_app_render',
  Subscription: 'subscription',
  RequestV2: 'request_v2',
  Product: 'product',
  Product360Viewer: 'product360viewer',
  ProductARViewer: 'glbfile',
  JoinOrgRequest: 'join_organization_request',
  ProductPageShare:"ProductPageShare"
};
// notification filter: below are the status for notification ( currently below two are not in use )
// UpdateOrAnnouncementFromLiveFurnishApp: 'update_or_announcement_from_live_furnish',
// PAYMENT_AND_TRANSACTION: 'payment_and_transaction',

export const CARD_TYPE = {
  PROJECT: 'projects',
  PRODUCT_CONFIGURATOR: 'product_configurator',
  AUTOMATION: 'automation',
  CONFIGURATORS: 'configurators',
  AUTOMATION_DETAILS: 'automation-details',
  RETAIL_AUTOMATION: 'retail-automation',
  ImagineAI: 'imagine-ai',
  PRODUCT_BUILDER: 'product-builder',
};

const SHARED_FILES_CARD_BANNER = {
  [MODEL_TYPES.PRODUCT]: {
    title: 'Product',
    cardType: 'props',
    button: [2, 3, 4, 5],
    clickUrl: (id) => getCuratorPath(id, 'product'),
  },
  [MODEL_TYPES.TEXTURE]: {
    title: 'Texture',
    cardType: 'textures',
    button: [1, 2, 3, 4, 5],
    clickUrl: () => { },
  },
  [MODEL_TYPES.ROOM]: {
    title: 'Room',
    cardType: 'templates',
    button: [2, 3, 4, 5],
    clickUrl: (id) => `/templates/${id}`,
  },
  [MODEL_TYPES.PROJECTS]: {
    title: 'Project',
    cardType: 'project',
    button: [1, 2, 3, 4, 5],
    clickUrl: (id) => getCuratorPath(id, 'projects'),
  },

  [MODEL_TYPES.COLLECTION]: {
    title: 'Collection',
    cardType: 'collection',
    button: [3, 5],
    clickUrl: (id) => `/collections/${id}`,
  },
  [MODEL_TYPES.PROJECTRENDER]: {
    title: 'Render&Preview',
    cardType: 'renders-previews',
    button: [1, 2, 3, 4, 5],
    clickUrl: (id) => RENDER_DETAILS_V2.replace(':id', id),
  },
};

export const SETTINGS_TAB = {
  DETAILS: 'details',
  PLANS: 'plans',
  BILLING: 'billing',
  MEMBERS: 'members',
  ADD_ONS: 'addons',
  NOTIFICATIONS: 'notifications',
  INTERESTS: 'interests',
  TRANSACTIONS: 'transactions',
  PRODUCT_HISTORY: 'productHistory',
  ORGANIZATION: 'organization',
  API_KEY:"apiKey"
};

export const NEW_MODAL = "NewModel"
export const REQUESTS_TYPE_LABEL = {
  NewModel: 'New model from images',
  Existing: 'With existing 3d model',
  Variation: 'Existing model variations',
};

export const ROOM_FILTER_TYPE = FILTER_MODEL_TYPE.ROOM;
export const MATERIAL_FILTER_TYPE = FILTER_MODEL_TYPE.MATERIAL
export const CATEGORY_FILTER_NAME = 'category';
export const CATEGORY_FILTER_TYPE = FILTER_MODEL_TYPE.ROOM;
export const CATEGORY_FILTER_ID = 9;

export const STYLE_FILTER_NAME = 'Style';
export const STYLE_FILTER_TYPE = FILTER_MODEL_TYPE.ROOM;
export const STYLE_FILTER_ID = 12;

export const PRODUCT_CATEGORY_FILTER_NAME = 'category';
export const PRODUCT_FILTER_TYPE = FILTER_MODEL_TYPE.PROPS;

export const PROJECT_FILTER_TYPE = FILTER_MODEL_TYPE.ROOM;
export const TEXTURE_FILTER_TYPE = FILTER_MODEL_TYPE.TEXTURE;

export const ONE_SECOND = 1000;
export const ONE_MINUTE = 60 * ONE_SECOND;

// My team constants
export const ROLE_ORG_OWNER = 3;
export const ROLE_ORG_ADMIN = 6;
export const ROLE_ORG_INTERNAL_USER = 5;
export const ROLE_ORG_EXTERNAL_USER = 7;

export const ALLOWED_MIME_TYPES = ['image/png', 'image/jpg', 'image/jpeg'];
export const SHEET_FILE_TYPE = [
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'text/csv',
];
export const ALLOWED_TEXTURE_FILE_TYPES = [...ALLOWED_MIME_TYPES, ...SHEET_FILE_TYPE];

export const API_ZIP_FILES_UPLOAD_STATUS = {
  NOT_DONE: 1,
  UPLOADED: 2,
  IN_PROGRESS: 3,
  DONE: 4,
  FAILED: 5,
  UPLOAD_IN_PROGRESS: 6,
};

export const API_UPLOAD_TYPE = {
  NORMAL: 1,
  GOOGLE: 2,
  DROP_BOX: 3,
};

export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;
export const GOOGLE_REAPTCHA_V2_KEY = process.env.REACT_APP_GOOGLE_RECAPTCHA_KEY;

export const FRAPPE_APP_URL = process.env.REACT_APP_FRAPPE_APP_URL;

export const GOOGLE_API_KEY = process.env.REACT_APP_GOOGLE_API_KEY;
export const DROPBOX_APP_KEY = process.env.REACT_APP_DROPBOX_APP_KEY;

export const IS_DEV = process.env.NODE_ENV === 'development';

const constants = {
  TRASH_MODEL_TYPE,
  PROJECT_TYPE_OPTIONS,
  TEMPLATE_TYPE_OPTIONS,
  FILTER_MODEL_TYPE,
  RENDER_STATUS,
  RENDER_STATUS_OPTIONS,
  INTERNAL_USER_ROLES,
  USER_ROLES,
  MODULE_TYPES,
  COLLECTION_PROPS,
  FILTER_TYPES,
  SHARED_FILES_CARD_BANNER,
  collectionFriendlyTitle,
};

export default constants;

export const MAX_PREVIEW_RESOLUTION = 1500;

// export const ALLOWED_EXCEL_MIME_TYPES = [".xlsx", ".xls", ".csv", "application/vnd.ms-excel", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "text/csv"];
export const ALLOWED_EXCEL_MIME_TYPES = [
  '.xlsx',
  '.xls',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
];

export const ALLOWED_DWG_MIME_TYPES = ['image/x-dwg', 'image/x-dxf', 'drawing/x-dwf'];

export const ALLOWED_3D_MIME_TYPES = ['.fbx', '.blend', '.cad'];
export const ACCEPT_3D_MODELS = [
  '.gltf',
  '.glb',
  '.obj',
  '.fbx',
  '.blend',
  '.usdz',
  '.zip',
  'model/gltf-binary',
  'application/x-blender',
  'model/vnd.usdz+zip',
  'application/zip',
  '.stl',
  '.dae',
  '.ply',
  '.abc',
  '.bvh',
  '.x3d',
  '.wrl',
  '.3ds',
  '.max',
  '.off',
  '.step',
  '.stp',
  '.iges',
  '.igs',
  '.brep',
  '.ifc',
  '.wrl',
  '.3mf',
  // ".skp", // Removing .skp file support
  '.fcstd',
  '.fcstd1',
];
export const ACCEPT_TEXTURES_TYPES = [
  '.jpeg',
  '.jpg',
  '.png',
  'image/jpeg',
  'image/jpg',
  'image/png',
];
export const ACCEPT_3D_MODELS_IN_ZIP = '.gltf, .fbx, .obj, .blend, .dae, .x3d, .wrl, .3ds, .max';

export const ALLOWED_MEASUREMENT_MIME_TYPES = [
  ...ALLOWED_EXCEL_MIME_TYPES,
  ...ALLOWED_DWG_MIME_TYPES,
  ...ALLOWED_MIME_TYPES,
  '.pdf',
];

export const ACCEPTABLE_IMAGE_TYPE = [
  'image/jpeg',
  'image/jpg',
  'image/png',
  'image/tiff',
  'image/webp',
];

// Support mime types for this library 
// https://3dviewer.net/
export const THREE_D_VIEWER_ACCEPTED_MIME_TYPES = ['3dm','3ds','3mf','amf','bim','brep','dae','fcstd','ifc','iges','step','stl','off','ply','wrl']

export const REQUEST_STATUSES = {
  PURCHASED: {
    value: 'PURCHASED',
    label: 'Purchased',
  },
  DRAFT: {
    value: 'DRAFT',
    label: 'Draft',
  },
  SUBMITTED: {
    value: 'SUBMITTED',
    label: 'Submitted',
  },
  ACCEPTED: {
    value: 'ACCEPTED',
    label: 'Accepted',
  },
  IN_PROGRESS: {
    value: 'IN_PROGRESS',
    label: 'In-progress',
  },
  FEEDBACK: {
    value: 'FEEDBACK',
    label: 'Feedback',
  },
  APPROVED: {
    value: 'APPROVED',
    label: 'Approved',
  },
  FOR_APPROVAL: {
    value: 'FOR_APPROVAL',
    label: 'For approval',
  },
  LIVE_ON_APP: {
    value: 'LIVE_ON_APP',
    label: 'Live on app',
  },
  TESTING: {
    value: 'TESTING',
    label: 'Testing',
  },
  CANCELLED: {
    value: 'CANCELLED',
    label: 'Cancelled',
  },
  QUERY: {
    value: 'QUERY',
    label: 'Query',
  },
};

export const REQUEST_STATUS = {
  [REQUEST_STATUSES.SUBMITTED.value]: {
    label: REQUEST_STATUSES.SUBMITTED.label,
  },
  [REQUEST_STATUSES.ACCEPTED.value]: {
    label: REQUEST_STATUSES.ACCEPTED.label,
  },
  [REQUEST_STATUSES.IN_PROGRESS.value]: {
    label: REQUEST_STATUSES.IN_PROGRESS.label,
  },
  [REQUEST_STATUSES.FOR_APPROVAL.value]: {
    label: REQUEST_STATUSES.FOR_APPROVAL.label,
    otherKey: REQUEST_STATUSES.FEEDBACK.value,
  },
  [REQUEST_STATUSES.LIVE_ON_APP.value]: {
    label: REQUEST_STATUSES.LIVE_ON_APP.label,
  },
};

export const STATUS = [
  {
    id: 11,
    name: REQUEST_STATUSES.QUERY.label,
    value: REQUEST_STATUSES.QUERY.value,
    color: 'lightBlue',
  },
  {
    id: 0,
    name: REQUEST_STATUSES.PURCHASED.label,
    value: REQUEST_STATUSES.PURCHASED.value,
    color: '#770dff',
  },
  {
    id: 1,
    name: REQUEST_STATUSES.DRAFT.label,
    value: REQUEST_STATUSES.DRAFT.value,
    color: 'green',
  },
  {
    id: 2,
    name: REQUEST_STATUSES.SUBMITTED.label,
    value: REQUEST_STATUSES.SUBMITTED.value,
    color: '#de6530',
  },
  {
    id: 3,
    name: REQUEST_STATUSES.ACCEPTED.label,
    value: REQUEST_STATUSES.ACCEPTED.value,
    color: '#7b68ee',
  },
  {
    id: 4,
    name: REQUEST_STATUSES.IN_PROGRESS.label,
    value: REQUEST_STATUSES.IN_PROGRESS.value,
    color: '#CCCCFF',
  },
  {
    id: 5,
    name: REQUEST_STATUSES.FOR_APPROVAL.label,
    value: REQUEST_STATUSES.FOR_APPROVAL.value,
    color: 'blue',
  },
  {
    id: 6,
    name: REQUEST_STATUSES.FEEDBACK.label,
    value: REQUEST_STATUSES.FEEDBACK.value,
    color: 'orange',
  },
  {
    id: 7,
    name: REQUEST_STATUSES.APPROVED.label,
    value: REQUEST_STATUSES.APPROVED.value,
    color: 'violet',
  },
  {
    id: 8,
    name: REQUEST_STATUSES.TESTING.label,
    value: REQUEST_STATUSES.TESTING.value,
    color: 'grey',
  },
  {
    id: 9,
    name: REQUEST_STATUSES.LIVE_ON_APP.label,
    value: REQUEST_STATUSES.LIVE_ON_APP.value,
    color: 'black',
  },
  {
    id: 10,
    name: REQUEST_STATUSES.CANCELLED.label,
    value: REQUEST_STATUSES.CANCELLED.value,
    color: 'pink',
  },
];

export const PRODUCT_DETAILS_TAB = {
  SHOWCASE: 'Showcase',
  FILES: 'Files',
};

export const PRODUCT_CATEGORY_VALUE = {
  CATEGORY: 1,
  SUB_CATEGORY: 15,
};

export const PRODUCT_ROOM_TYPE_VALUE = {
  SILO: 1,
  LIFESTYLE: 2,
  VIGNETTE: 3,
  UPLOAD_GIF: 4,
  UPLOAD_IMAGES: 5,
};
export const PRODUCT_DETAILS_PAGE_LABEL = {
  UPLOAD_LABEL: 'Renders',
  UPLOAD_VALUE: 'upload',
  DELETE_ALL_LABEL: 'Delete All',
  DELETE_ALL_VALUE: 'Delete All',
  DOWNLOAD_LABEL: 'Download',
  DOWNLOAD_VALUE: 'Download',
  EDIT_IN_3D_LABEL: 'Edit in 3D',
  EDIT_IN_3D_VALUE: 'Edit in 3D',
  EDIT_LABEL: 'Edit',
  EDIT_VALUE: 'Edit',
  DELETE_LABEL: 'Delete',
  DELETE_VALUE: 'Delete',
  RENAME_LABEL: 'Rename',
  RENAME_VALUE: 'Rename',
  RE_ORDER_LABEL: 'Re-Order',
  RE_ORDER_VALUE: 'Re-Order',
  UPLOAD_GIF_LABEL: 'GIF',
  UPLOAD_GIF_VALUE: 'UPLOAD_GIF',
  UPLOAD_IMAGE_LABEL: 'Images',
  UPLOAD_IMAGE_VALUE: 'UPLOAD_IMAGES',
  UPLOAD_PANNING_VIDEO_LABEL: 'Upload Panning Video',
  UPLOAD_PANNING_VIDEO_VALUE: 'UPLOAD_PANNING_VIDEO',
  EDIT_PANNING_VIDEO_LABEL: 'Edit Panning Video',
  EDIT_PANNING_VIDEO_VALUE: 'Edit_PANNING_VIDEO',
  DELETE_PANNING_VIDEO_LABEL: 'Delete Panning Video',
  DELETE_PANNING_VIDEO_VALUE: 'DELETE_PANNING_VIDEO',
};

export const HIDE_FULL_SCREEN_OPTION_LIST = [
  'Share',
  'Add to Collection',
  'Archive',
  'Restore',
  'Buy Image',
  'Remove watermark',
];

export const LIFE_STYLE_UPLOAD_TAB = {
  LIFESTYLE: 1,
  VIGNETTE: 2,
  SILOS: 3,
  UPLOAD_GIF: 4,
  UPLOAD_IMAGES: 5,
};
export const LIFE_STYLE_UPLOAD_TAB_LABEL = {
  1: 'Lifestyle',
  2: 'Vignette',
  3: 'Silos',
  4: 'Upload GIF',
  5: 'Upload Images',
};

export const HIDE_SECTION = [
  '/product/public/',
  '/products/preview/',
  '/p-ar-viewer/',
  '/ar-viewer/',
  '/products/video-preview/',
  '/requests/new/',
  '/requests/new',
  '/requests/edit/',
  '/privacypolicy',
  '/termsofuse',
  '/sla-agreement',
  '/curator/builder',
  ADMIN_MY_PRODUCTS_TEXTURE_EDIT_V2,
  ADMIN_MY_PRODUCTS_3DMODAL_EACH_V2.replaceAll(':id', ''),
  ADMIN_MY_PRODUCTS_TEXTURES_EACH_V2.replaceAll(':id', ''),
  ADMIN_MY_PRODUCTS_3DMODAL_EACH_PUBLIC_V2.replaceAll(':id', ''),
  ADMIN_MY_TEXTURES_3DMODAL_EACH_PUBLIC_V2.replaceAll(':id', ''),
  PRODUCT_360_VIEWER_PUBLIC_V2.replaceAll(':id', ''),
  TEXTURE_360_VIEWER_PUBLIC_V2.replaceAll(':id', ''),
  PRODUCT_VIDEO_PUBLIC_V2.replaceAll(':id', ''),
  TEXTURE_VIDEO_PUBLIC.replaceAll(':id', ''),
  PRODUCT_AR_VIEWER_PUBLIC_V2.replaceAll(':id', ''),
  PRODUCT_3D_VIEWER_PUBLIC_V2.replaceAll(':id', ''),
  PRODUCT_AI_VIDEO_PUBLIC_V2.replaceAll(':id', ''),
  PRODUCT_AI_VIDEO_PUBLIC_TEXTURE_V2.replaceAll(':id', ''),
  CONFIGURATOR_PUBLIC_VIEWER_ROUTE.replaceAll(':modelId', ''),
  CONFIGURATOR_PUBLIC_VIEWER_ROUTE_TEXTURE_V2.replaceAll(':modelId', ''),
];

export const HIDE_ASSIGN_PACKS_MODAL = [
  ...HIDE_SECTION.map((a) => (a[a.length - 1] === '/' ? a.substring(0, a.length - 1) : a)),
];

export const REQUESTS_MENU_TAB = {
  MODELS: { title: '3D Model Requests', eventKey: 'models' },
  PDP: { title: 'PDP Requests', eventKey: 'pdp' }
};

export const RETAIL_MENU_TAB = {
  CONFIGURATOR: { title: 'Create Content', eventKey: 'configurator' },
  AUTOMATION: { title: 'Create Template', eventKey: 'automation' }
};

export const LIBRARY_MENU_TAB = {
  TEMPLATES: { title: 'Templates', eventKey: 'Templates' },
  PROPS: { title: 'Props', eventKey: 'Props' }
};
export const MY_PRODUCTS_MENU_TAB = {
  MODLES: { title: 'Models', eventKey: 'Models' },
  ROOMS: { title: 'Rooms', eventKey: 'Rooms' },
  TEXTURES: { title: 'Textures', eventKey: 'Textures' },
  CUSTOMMAP: { title: 'Custom Maps', eventKey: 'CustomMaps' },
  MATERIALS: { title: 'Materials', eventKey: 'Materials' },
  SHARED_PRODUCT_PAGE: { title: 'Shared Product Page', eventKey: 'SharedProductPage' },
};

export const MY_FILES_MENU_TAB = {
  PROJECTS: { title: 'Projects', eventKey: 'Projects' },
  IMAGES: { title: 'Images', eventKey: 'Images' },
  AUTOMATION: { title: 'Automation', eventKey: 'Automation' },
  CONFIGURATORS: { title: 'Configurators', eventKey: 'Configurators' },
  PRODUCT_CONFIGURATORS: { title: 'Configurators', eventKey: 'ProductConfigurators' },
  IMAGINE_AI: { title: 'Imagine AI', eventKey: 'ImagineAI' },
  RETAIL_AUTOMATION: { title: 'Retail Automation', eventKey: 'RetailAutomation' },
  SHARED_FILES: { title: 'Shared', eventKey: 'SharedFiles' },
  PRODUCT_BUILDER: { title: 'Mattress Builder', eventKey: 'ProductBuilder' },
};

export const SHARED_FILES_MENU_TAB = {
  SHARE_WITH_ME: { title: 'Shared with me', eventKey: 'ShareWithMe' },
  SHARE_WITH_TEAM: { title: 'Shared with team', eventKey: 'SharedWithTeam' },
  SHARE_WITH_ORG: { title: 'Shared with organization', eventKey: 'SharedWithOrganization' },
  ALL: { title: 'Shared', eventKey: 'all' },
};
export const TRASH_MENU_TAB = {
  MY_PRODUCTS: { title: 'My Products', eventKey: 'myProducts' },
  MY_FILES: { title: 'My Files', eventKey: 'myFiles' },
  ALL: { title: 'Trash', eventKey: 'all' },
};

export const NOTIFICATION_MENU_TAB = {
  ALL: { title: 'All', eventKey: 'all' },
  UNREAD: { title: 'Unread', eventKey: 'unread' },
  MUTE: { title: 'Mute', eventKey: 'mute' },
};

export const openProjectInCurator = '/curator/project/';

// export const LEFT_SIDE_ACTIVE_MENU_ROUTES = {
// MY_FILES: [ADMIN_MY_PRODUCTS_3DMODAL],
// }

export const BANNER_TYPE = {
  IMAGE: 1,
  VIDEO: 2,
  TEXT: 3,
};
export const PRODUCT_PAGE_NAVIGATION_KEY = {
  NEXT: 'next',
  PREVIOUS: 'prev',
};

export const FAST_PREVIEW = {
  FINISHED: 'FINISHED',
  CANCELLED: 'CANCELLED',
};

export const FAST_PREVIEW_TIMER_VALUE = 120

export const LIFESTYLE_ROOM_VALUE = '2';
export const DEFAULT_CAMERA_PX_VALUE = 1000;

export const NONE_OPTION_VALUE = { label: 'None', value: '' };

export const REMOVE_SORT_PARAM_ROUTES = [
  ADMIN_MY_PRODUCTS_ROOMS_V2,
  ADMIN_MY_PRODUCTS_3DMODAL_V2,
  TEMPLATES_ROUTE_V2,
  ADMIN_MY_PROPS_V2,
  ADMIN_MY_PRODUCTS_3DMODAL_EACH,
];

export const THREE_D_FILE_DOWNLOADS = {
  [MODEL_TYPES.PRODUCT]: 'product',
  [MODEL_TYPES.TEMPLATES]: 'room',
  [MODEL_TYPES.PROJECTS]: 'project',
  [MODEL_TYPES.PROJECTRENDER]: 'render',
};

// tutorial page
export const TUTORIAL = 'TUTORIAL';
export const TIPS_AND_TRICKS = 'TIPSANDTRICS';

export const TUTORIAL_SECTION_OPTIONS = {
  HOME: 'home',
  TUTORIAL: 'tutorial',
  TIPS_AND_TRICKS: 'tips',
};

// props group options
const ARCHIVED_OPTION = {
  apiValue: true,
  key: 'is_archived',
  label: 'Archived',
  value: 'ARCHIVED',
};
// group options
const DELETED_OPTION = {
  apiValue: true,
  key: 'is_delete_on_expire',
  label: 'Deleted',
  value: 'DELETED',
};
export const NONE_OPTION = { label: 'None', value: '' };
export const FILTER_BY_OPTIONS_LIST = [NONE_OPTION, ARCHIVED_OPTION];
export const FILTER_BY_DELETE_OPTIONS_LIST = [NONE_OPTION, DELETED_OPTION];
export const RANDOMIZE_TILE_PATTERN = 'randomised floor';

export const PACK_USER_MODE = 'pack';

export const COLOR_HEX_LENGTH = 7;
export const MEASURE_TOOL_ALL_LINES = 7;

export const SKIP_BRAND_FILTER_MODULE = [
  MODEL_TYPES?.THREEDMODELS,
  MODEL_TYPES?.ROOM,
  MODEL_TYPES?.TEXTURE,
  MODEL_TYPES?.UPLOADS,
];

export const SUBSCRIPTION_MODEL_TYPE = {
  THREE_D_MODEL: '3D Model',
  THREE_D_MODEL_VARIATION: '3D Model variation',
};
export const PROGRESS_BAR_TYPES = {
  HARD_WARNING: 'hard_warning',
  WARNING: 'warning',
  DANGER: 'danger',
  SUCCESS: 'success',
};

export const frequency = {
  '1_1': 'Monthly',
  '1_3': 'Quarterly',
  '1_6': 'Per six months',
  '2_1': 'Yearly',
  '2_2': 'Per two years',
  '2_3': 'Per three years',
  '2_4': 'Per four years',
  '2_5': 'Per five years',
};

export const MENU_TYPE = {
  JOIN_DISCORD: 'JOIN_DISCORD',
  JOIN_INSTAGRAM: 'JOIN_INSTAGRAM',
  CONTACT_SUPPORT_FORM: 'SUPPORT_FORM',
  FEEDBACK: 'FEEDBACK',
  LOGOUT: 'LOGOUT',
  MY_PLANS: 'MY_PLANS',
};

export const UNLIMITED_RENDERING = 'Unlimited Rendering';
export const UNLIMITED_AI_GENERATION = 'Unlimited AI Generation';

export const MATTRESS_BUILDER_BASE_TYPE = 'Mattress Builder';
export const IMAGINE_CREDIT_BASE_TYPE = 'Imagine Credits';
export const IMAGINE_PDP_CREDIT_BASE_TYPE = 'PDP Credits';
export const TEXTURE_BASE_TYPE = 'Texture';
export const THREE_3D_MODAL_BASE_TYPE = '3D Models Upload Limit';
export const IMAGINE_DISCORD_CHANNEL = 'https://discord.com/invite/VCHYeZgSUW'; // "https://discord.gg/9Kn9Npum"
export const IMAGINE_INSTAGRAM_CHANNEL = 'https://www.instagram.com/channel/AbZe4HdjSzNslbmi/';

export const TEXTURE_BASE_TYPE_CONTENT_TYPE = 204;
export const MODEL_BASE_TYPE_CONTENT_TYPE = 397;

export const HIDE_ARROW_TYPES  = [IMAGINE_CREDIT_BASE_TYPE , IMAGINE_PDP_CREDIT_BASE_TYPE]

export const UPLOAD_LIMIT_TYPE_LABEL = 'uploadPlanType';

// param keys for userpilot - Do not make change it
export const OPEN_IMAGES = 'openImages';
export const IS_SHARED = 'isShared';
export const CURATOR_OPEN_SOURCE = 'curatorOpenSource';
export const UP_RENDER_ID = 'renderId';
export const UP_IS_EXPAND = 'is_expand';
export const UP_MODEL_ID = 'model_id';
export const UP_MODEL_NAME = 'model_name';
export const UP_UPLOAD_TYPE = 'upload_type';
export const UP_UPLOAD_EXTENSION = 'upload_extension';
export const UP_FILE_NAME = 'file_name';
export const UP_HOTSPOT_NAME = 'hotspot_name';
export const UP_MAIN_ORIGIN = 'main_origin';
export const USERPILOT_UUID = 'USERPILOT_UUID';

export const FREE_CREDITS_RESOLUTION_LIMIT = 2000;

export const RETAIL_AUTOMATION_DELETED_PROPS_LIST = 'RETAIL_AUTOMATION_DELETED_PROPS_LIST';

// userpilot
export const USERPILOT_FUNCTIONS = {
  OnCameraRotate: 'OnCameraRotate',
  OnCameraPan: 'OnCameraPan',
  OnCameraZoomInOut: 'OnCameraZoomInOut',
  HighlightObjectReceiver: 'HighlightObjectReceiver',
  SelectObjectReceiver: 'SelectObjectReceiver',
  FocusObjectReceiver: 'FocusObjectReceiver',
  StartGizmoBlinking: 'StartGizmoBlinking',
  OpenProductsTab: 'OpenProductsTab',
  OpenStyleTab: 'OpenStyleTab',
  OpenCamerasTab: 'OpenCamerasTab',
  OpenLightTab: 'OpenLightTab',
  OpenImagesTab: 'OpenImagesTab',
  OpenSettingsTab: 'OpenSettingsTab',
  OpenMetadataTab: 'OpenMetadataTab',
  OpenTileAndGroutTab: 'OpenTileAndGroutTab',
  OpenAutomationTab: 'OpenAutomationTab',
  OpenMoreTab: 'OpenMoreTab',
  CloseCuratorSidebarSection: 'CloseCuratorSidebarSection',
  OpenStyleTextureTab: 'OpenStyleTextureTab',
  OpenStyleMaterialTab: 'OpenStyleMaterialTab',
  OpenStyleColorTab: 'OpenStyleColorTab',
  OpenStylePropertiesTab: 'OpenStylePropertiesTab',
};

// onboard user
export const COMPONENT_LOAD_NAMES = {
  CHOOSE_YOUR_ORG: 'chooseYourOrg',
  REQUEST_SENT: 'requestSent',
  CREATE_NEW_ORG: 'createNewOrg',
  ASSIGN_EDITOR: 'assignEditor',
};

export const ORG_JOIN_REQUEST_STATUS = {
  APPROVED: 'approved',
  DENIED: 'rejected',
  NEW: 'new',
};

// texture upload from types
export const TEXTURE_FILTER_LABEL = 'Uploaded From';

export const TEXTURE_UPLOADS_FROM_TYPES = {
  MY_TEXTURE: 'My Texture',
  CURATOR: 'Curator',
  CONFIGURATOR: 'Configurator',
  MATTRESS_BUILDER: 'Mattress Builder',
};

export const HOME_TEMPLATE_CATEGORIES = {
  TRENDING: 'trending',
  KITCHEN: 'kitchen',
  LIVING_ROOM: 'living-room',
  COMMERCIAL_SPACE: 'commercial-space',
  OUTDOOR: 'outdoor',
  BEDROOM: 'bedroom',
  ABSTRACT: 'Abstract',
  // INTERIORS: 'interiors',
};

// TODO: We need to add category info here
export const HOME_TEMPLATE_CATEGORIES_INFO = {
  [HOME_TEMPLATE_CATEGORIES.TRENDING]: {
    id: 10005,
    filter_label__label_name: 'Space',
    filter_label: 23,
  },

  [HOME_TEMPLATE_CATEGORIES.KITCHEN]: {
    id: 2574,
    filter_label__label_name: 'Space',
    filter_label: 23,
  },

  [HOME_TEMPLATE_CATEGORIES.LIVING_ROOM]: {
    id: 2571,
    filter_label__label_name: 'Space',
    filter_label: 23,
  },

  [HOME_TEMPLATE_CATEGORIES.COMMERCIAL_SPACE]: {
    id: 9980,
    filter_label__label_name: 'Style',
    filter_label: 24,
  },

  [HOME_TEMPLATE_CATEGORIES.OUTDOOR]: {
    id: 2585,
    filter_label__label_name: 'Space',
    filter_label: 23,
  },

  [HOME_TEMPLATE_CATEGORIES.BEDROOM]: {
    id: 2561,
    filter_label__label_name: 'Space',
    filter_label: 23,
  },

  [HOME_TEMPLATE_CATEGORIES.ABSTRACT]: {
    id: 9400,
    filter_label__label_name: 'Space',
    filter_label: 23,
  },
};

export const HOME_TEMPLATE_CATEGORIES_TAB = [
  {
    id: 1,
    eventKey: HOME_TEMPLATE_CATEGORIES.TRENDING,
    title: 'Trending',
  },
  {
    id: 2,
    eventKey: HOME_TEMPLATE_CATEGORIES.KITCHEN,
    title: 'Kitchen',
  },
  {
    id: 3,
    eventKey: HOME_TEMPLATE_CATEGORIES.LIVING_ROOM,
    title: 'Living Room',
  },
  {
    id: 4,
    eventKey: HOME_TEMPLATE_CATEGORIES.COMMERCIAL_SPACE,
    title: 'Commercial Space',
  },
  {
    id: 5,
    eventKey: HOME_TEMPLATE_CATEGORIES.OUTDOOR,
    title: 'Outdoor',
  },
  {
    id: 6,
    eventKey: HOME_TEMPLATE_CATEGORIES.BEDROOM,
    title: 'Bedroom',
  },
  {
    id: 7,
    eventKey: HOME_TEMPLATE_CATEGORIES.ABSTRACT,
    title: 'Abstract',
  },
  // {
  //   id: 7,
  //   eventKey: HOME_TEMPLATE_CATEGORIES.INTERIORS,
  //   title: 'Interiors',
  // },
];

export const UPGRADE_POPUP_DASHBOARD = 'upgradePopup';
export const UPGRADE_POPUP_CURATOR = 'upgradepopupcurator';
export const POPULAR_CATEGORY_TAB = 'c';
export const TUTORIAL_TAB = 't';

export const MONTH_NAMES = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const DIMENSION_SHOT_VALUE = 'dimensions';
export const GIF_VALUE = 'GIF';

export const DIMENSION_SHOT_OPTIONS = { value: DIMENSION_SHOT_VALUE, label: 'Dimension shot' };
export const PRODUCT_IMAGES_OPTIONS = [...TEMPLATE_TYPE_OPTIONS, DIMENSION_SHOT_OPTIONS];

export const PRODUCT_LIFESTYLE_VIDEO = 'Lifestyle';
export const PRODUCT_PANNING_VIDEO = 'Panning';

export const PRODUCT_VIDEOS_OPTIONS = [
  {
    value: PRODUCT_LIFESTYLE_VIDEO,
    label: 'Lifestyle video',
  },
  {
    value: PRODUCT_PANNING_VIDEO,
    label: 'Panning video',
  },
];
export const PRODUCT_PAGE_GIF_SUPPORTED_TYPES = '.gif';
export const PRODUCT_PAGE_IMAGE_SUPPORTED_TYPES = '.jpg, .png';
export const PRODUCT_PAGE_VIDEO_SUPPORTED_TYPES = '.mp4';
export const PRODUCT_PAGE_FILE_SUPPORTED_TYPES = `${PRODUCT_PAGE_GIF_SUPPORTED_TYPES}, ${PRODUCT_PAGE_IMAGE_SUPPORTED_TYPES}, ${PRODUCT_PAGE_VIDEO_SUPPORTED_TYPES}`;
export const PRODUCT_PAGE_GIF_SUPPORTED_OPTION = [{ value: GIF_VALUE, label: 'GIF' }];

export const THUMBNAIL_MAX_RESOLUTION = 400;
export const THUMBNAIL_MAX_WIDTH_RESOLUTION = 544;
export const THUMBNAIL_MAX_HEIGHT_RESOLUTION = 432;

export const MODAL_UPLOAD_GUIDELINES_URL =
  'https://docs.google.com/presentation/d/1FmWXbKAjX-B1nsPZCh2Z4RjH96uXOX-smEI74YbSkT4/edit#slide=id.g3055939d932_0_44';

export const PRODUCT_BUILDER_PROP_TYPE = {
  TOP: 'top',
  WALL: 'wall',
  TAPE: 'tape',
  LABEL: 'label',
  HANDLE: 'handle',
  BOTTOM: 'bottom',
  LAYER: 'layer',
  SIZE: 'size',
  HEIGHT: 'height',
  INTERNAL_LAYER: 'internallayer',
  VARIANT: 'variant', // This is needed to fetch the property type associated with variant
  TUFTED_BUTTON: 'tuftedbutton',
  BUTTON: 'button'
};
export const FORGOT_PASSWORD_COUNT = 3;

export const MAX_MATTRESS_BUILDER_UNDO_REDO_STACK_SIZE = 20;

export const REQUEST_3D_FILE_FORMATS = [
  '.ma',
  '.mb',
  '.mc',
  '.ply',
  '.abc',
  '.glb',
  '.gltf',
  '.x3d',
  '.wrl',
  '.wrz',
  '.fbx',
  '.3ds',
  '.prj',
  '.catpart',
  '.catproduct',
  '.cgr',
  '.dae',
  '.dem',
  '.xml',
  '.ddf',
  '.dwg',
  '.flt',
  '.ige',
  '.igs',
  '.iges',
  '.jt',
  '.model',
  '.mdl',
  '.session',
  '.exp',
  '.dlv',
  '.dlv3',
  '.dlv4',
  '.obj',
  '.prt',
  '.neu',
  '.g',
  '.asm',
  '.rvt',
  '.sat',
  // '.skp', // Removing .skp file support
  '.sldprt',
  '.sldasm',
  '.stl',
  '.stp',
  '.step',
  '.usd',
  '.usda',
  '.usdc',
  '.usdz',
  '.max',
  '.zip',
];

export const REQUEST_SUPPORTED_FILE_FORMATS = [
  // Images
  '.jpg',
  '.jpeg',
  '.png',
  '.pdf',
  '.webp',
  '.bmp',
  '.raw',
  '.eps',
  '.svg',
  '.ai',
  '.psd',
  '.tiff',
  '.tga',
  '.gif',

  // Videos
  '.mp4',
  '.mp3',
  '.mov',
  '.wmv',
  '.avi',
  '.avchd',
  '.flv',
  '.f4v',
  '.swf',
  '.mkv',
  '.webm',
  '.h264',
  '.m4v',

  // 3D Files
  ...REQUEST_3D_FILE_FORMATS,

  // Data Files
  '.pps',
  '.ppt',
  '.pptx',
  '.key',
  '.ods',
  '.xls',
  '.xlsm',
  '.xlsx',
  '.doc',
  '.docx',
  '.odt',
  '.txt',
  '.pdf',
];

export const ACCEPTABLE_IMAGE_TYPE_REQUEST = ['.jpeg', '.jpg', '.png', '.tiff', '.webp'];
export const SENTRY_ERROR_TYPES = {
  ERROR: "error",
  WARNING: "warning",
  NOTIFICATION: "notification",
}

export const MODEL_SIZE_LIMIT = 1024
export const FAST_PREVIEW_TAG = "fast_preview"

// product page constant

export const PRODUCT_CATEGORY = {
  THREEDVIEWER: 1, // 'threedviewer',
  PRODUCTIMAGE: 4, // 'productimage',
  THREESIXTY: 6, // 'threesixty',
  DIMENSIONSHOT: 3, // 'dimensionshot',
  ARVIEWER: 2, // 'arviewer',
  VIDEO: 5, // 'video',
  CONFIGURATOR: 7, // 'configurator',
  GIF: 8, // 'gif',
};
 
export const TEXTURE_CATEGORY = {
  THREEDVIEWER: 1, // 'threedviewer',
  PRODUCTIMAGE: 2, // 'productimage',
  VIDEO: 3, // 'video',
  THREESIXTY: 4, // 'threesixty',
  CONFIGURATOR: 5, // 'configurator',
  GIF: 6, // 'gif',
};

// update the order of the category here if we change the order in the backend
export const DEFAULT_PRODUCT_CATEGORY_ORDER = {
  [PRODUCT_CATEGORY.THREEDVIEWER]: 1,
  [PRODUCT_CATEGORY.ARVIEWER]: 2,
  [PRODUCT_CATEGORY.DIMENSIONSHOT]: 3,
  [PRODUCT_CATEGORY.PRODUCTIMAGE]: 4,
  [PRODUCT_CATEGORY.VIDEO]: 5,
  [PRODUCT_CATEGORY.THREESIXTY]: 6,
  [PRODUCT_CATEGORY.CONFIGURATOR]: 7,
  [PRODUCT_CATEGORY.GIF]: 8,
};

// update the order of the category here if we change the order in the backend
export const DEFAULT_TEXTURE_CATEGORY_ORDER = {
  [TEXTURE_CATEGORY.THREEDVIEWER]: 1,
  [TEXTURE_CATEGORY.PRODUCTIMAGE]: 2,
  [TEXTURE_CATEGORY.VIDEO]: 3,
  [TEXTURE_CATEGORY.THREESIXTY]: 4,
  [TEXTURE_CATEGORY.CONFIGURATOR]: 5,
  [TEXTURE_CATEGORY.GIF]: 6,
  // [PRODUCT_CATEGORY.ARVIEWER]: 7,
  // [PRODUCT_CATEGORY.DIMENSIONSHOT]: 8,
};

export const EDIT_IMAGE_TOOLS = {
  TEMPERATURE : "Temperature",
  TINT : "Tint",
  BRIGHTNESS : "Brightness",
  CONTRAST : "Contrast",
  HIGHLIGHTS : "Highlights",
  SHADOWS : "Shadows",
  WHITES : "Whites",
  BLACKS : "Blacks",
  VIBRANCE : "Vibrance",
  SATURATION : "Saturation",
  SHARPNESS : "Sharpness",
  CLARITY : "Clarity",
  VIGNETTE : "Vignette",
  FILMIC_MODE : "Filmic Mode",
  COLOR_CORRECTION : "Color Correction",
  REMOVE_BACKGROUND: 'Remove Background',
  BACKGROUND_COLOR: 'Solid Color Background'
}

export const EDIT_IMAGE_TOOL_GROUP = [{
  name: "Color",
  options: [
    EDIT_IMAGE_TOOLS.FILMIC_MODE,
    EDIT_IMAGE_TOOLS.COLOR_CORRECTION,
    EDIT_IMAGE_TOOLS.SATURATION,
    EDIT_IMAGE_TOOLS.TEMPERATURE,
  ]
},
{
  name: "Details",
  options: [
    EDIT_IMAGE_TOOLS.SHARPNESS,
    EDIT_IMAGE_TOOLS.CONTRAST
  ]
},
{
  name: "Light",
  options: [
    EDIT_IMAGE_TOOLS.BRIGHTNESS,
    EDIT_IMAGE_TOOLS.HIGHLIGHTS,
    EDIT_IMAGE_TOOLS.SHADOWS,
    EDIT_IMAGE_TOOLS.WHITES,
    EDIT_IMAGE_TOOLS.BLACKS,
  ]
},
{
  name: "Background",
  options: [
    EDIT_IMAGE_TOOLS.REMOVE_BACKGROUND,
    EDIT_IMAGE_TOOLS.BACKGROUND_COLOR
  ]
}
]


export const EDIT_IMAGE_TOOL_OPTIONS = [
  EDIT_IMAGE_TOOLS.TEMPERATURE,
  EDIT_IMAGE_TOOLS.TINT,
  EDIT_IMAGE_TOOLS.BRIGHTNESS,
  EDIT_IMAGE_TOOLS.CONTRAST,
  EDIT_IMAGE_TOOLS.HIGHLIGHTS,
  EDIT_IMAGE_TOOLS.SHADOWS,
  EDIT_IMAGE_TOOLS.WHITES,
  EDIT_IMAGE_TOOLS.BLACKS,
  EDIT_IMAGE_TOOLS.VIBRANCE,
  EDIT_IMAGE_TOOLS.SATURATION,
  EDIT_IMAGE_TOOLS.SHARPNESS,
  EDIT_IMAGE_TOOLS.CLARITY,
  EDIT_IMAGE_TOOLS.VIGNETTE,
  EDIT_IMAGE_TOOLS.FILMIC_MODE,
  EDIT_IMAGE_TOOLS.COLOR_CORRECTION,
]

export const CAMERA_DEFAULT_FIELDS = [
  "id",
  "cameraName",
  "distanceToSet",
  "fov",
  "horizontalFov",
  "xTransRot",
  "yTransRot",
  "zTransRot",
  "centerObjectxPos",
  "centerObjectyPos",
  "centerObjectzPos",
  "isCameraCorrection",
  "lensShiftY",
  "cameraHeight",
  "cameraRotX",
  "cameraRotZ",
  "focalLength",
  "isdepthOfField",
  "selectedObjectName",
  "blurIntensity",
  "resoX",
  "resoY",
  "xPos",
  "zPos",
  "yPos",
  "isPredefinedCamera",
  "focusXPos",
  "focusYPos",
  "focusZPos",
  "canvas_width",
  "canvas_height",
  "sensor_width",
  "sensor_height",
  "fov_axis",
  "gate_fit",
  "dpi",
]

export const HIDE_INVITE_PERMISSION_LIST = ['lf_invite_internal_can_create_configurator']

export const THUMBNAIL_CARD_DATE_FORMAT = 'MM/DD/YYYY hh:mm:ss A'
export const IMAGINE_EDITOR_COPY_KEY = "__IMAGINE_EDITOR_SETTINGS__"
